export default __webpack_public_path__ + "static/media/qr-code.fad81553.svg";